import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"

const ReferenceContainer = props => {
  const qwery = props.data

  const blockCount = qwery.length

  const maxWidthClass =
    blockCount === 3 ? "lg:max-w-[400px]" : "lg:max-w-[555px]"

  const referenceBlockMaker = (cardData, index) => {
    return (
      <Link
        className={`${maxWidthClass} bg-white rounded-3xl relative overflow-hidden group md:my-10 my-4 lg:min-w-[340px] xl:min-w-[400px] min-h-[500px] lg:mx-0 mx-4 `}
        to={"/" + cardData.slug}
        key={index}
      >
        <div className="overflow-hidden max-h-[275px] bg-black">
          <GatsbyImage
            className="transition-all group-hover:scale-125 group-hover:opacity-50 md:w-full object-cover h-[275px]"
            image={cardData.headerImage[0].gatsbyImageData}
            alt={cardData.headerImage[0].description || "image"}
          />
        </div>
        {cardData.companyName ? (
          <span className="absolute p-3 bg-white top-[200px] rounded left-8 text-gray-500 text-[14px] font-bold">
            {cardData.companyName}
          </span>
        ) : (
          <></>
        )}
        {/* Code for Company name
        <span className="absolute p-3 bg-white top-[200px] left-8 text-gray-500 text-[17px] font-bold">
          G&S Bouw
        </span> */}
        <div className={`flex`}>
          <h5
            className={`w-[80%] mx-8 mt-8 min-h-[64px] text-2xl font-bold text-[28px] overflow-hidden text-edc-dark-blue`}
            style={{
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 4
            }}
          >
            {cardData.titleForOverviewPage}
          </h5>
          {/* <div className="w-[20%] bordml-auto"> */}
          <img
            src="https://images.ctfassets.net/rh7phaxwpmak/3uYNvArGGdasNhNtXusJ3c/07afd92357890edd77e058f5fc5c7e03/Group_16.svg"
            className={`absolute w-[60px] h-[60px] right-4 self-end my-auto pb-[10px] bottom-3 `}
            alt="arrow-image"
          />
          {/* </div> */}
        </div>
      </Link>
    )
  }
  return (
    <div className="bg-[#f4f4f4]">
      <div className="flex lg:justify-around md:justify-center lg:max-w-[1310px] mx-auto md:my-0 my-[30px] lg:gap-[55px] flex-col lg:flex-row">
        {qwery.map((block, index) => {
          if (block.slug) {
            return referenceBlockMaker(block, index)
          } else {
            return ""
          }
        })}
      </div>
    </div>
  )
}

export default ReferenceContainer
